// document.addEventListener("DOMContentLoaded", function () {
//   const offerBox = document.querySelector(".offer-box");
//   if (!offerBox) return;

//   const price = parseFloat(offerBox.dataset.price);
//   if (!isNaN(price)) {
//     updateDiscountedPrice(price);
//   }
// });

// // Function to update the discounted price and coupon code
// function updateDiscountedPrice(price) {
//   let discount = 0;
//   let couponCode = "";

//   if (price > 19995) {
//     discount = 0.15;
//     couponCode = "MANN15";
//   } else if (price > 9995) {
//     discount = 0.1;
//     couponCode = "MANN10";
//   } else if (price >= 4995) {
//     discount = 0.07;
//     couponCode = "MANN7";
//   }

//   let discounted = price - price * discount;
//   discounted -= discounted * 0.05; // Extra prepaid discount

//   document.getElementById("discounted-price").innerText = `₹${discounted.toFixed(2)}`;
//   document.getElementById("applied-coupon").innerText = couponCode;
//   document.getElementById("copy-btn").setAttribute("data-code", couponCode);
// }

// // Listen for Shopify variant change event
// document.addEventListener("variant:changed", function (event) {
//   const newPrice = event.detail.variant.price / 100; // Shopify gives price in paise
//   const offerBox = document.querySelector(".offer-box");

//   if (!offerBox || isNaN(newPrice)) return;

//   offerBox.setAttribute("data-price", newPrice.toFixed(2));
//   updateDiscountedPrice(newPrice);
// });

// // Copy coupon code to clipboard
// function copyCoupon() {
//   const code = document.getElementById("copy-btn").getAttribute("data-code");
//   navigator.clipboard.writeText(code).then(function () {
//     const btn = document.getElementById("copy-btn");
//     btn.innerText = "Copied!";
//     setTimeout(() => {
//       btn.innerText = "Copy";
//     }, 1500);
//   });
// }

document.addEventListener("DOMContentLoaded", function () {
  const offerBox = document.querySelector(".offer-box");
  if (!offerBox) return;

  const price = parseFloat(offerBox.dataset.price);
  if (!isNaN(price)) {
    updateDiscountedPrice(price);
  }
});

// Function to update the discounted price and coupon code
function updateDiscountedPrice(price) {
  let discount = 0;
  let couponCode = "";

  if (price > 19995) {
    discount = 0.15;
    couponCode = "MANN15";
  } else if (price > 9995) {
    discount = 0.1;
    couponCode = "MANN10";
  } else if (price >= 4995) {
    discount = 0.07;
    couponCode = "MANN7";
  }

  let discounted = price - price * discount;
  discounted -= discounted * 0.05; // Extra prepaid discount

  document.getElementById("discounted-price").innerText = `₹${discounted.toFixed(2)}`;

  const copyBtn = document.getElementById("copy-btn");
  const infoText = document.getElementById("discount-info");

  if (couponCode) {
    // Show coupon + prepaid discount text and Copy button
    infoText.innerHTML = `Includes <span class="coupon-text">${couponCode}</span> coupon + prepaid discount`;
    copyBtn.style.display = "inline-block";
    copyBtn.setAttribute("data-code", couponCode);
  } else {
    // Only prepaid discount text, hide Copy button
    infoText.innerText = "Includes prepaid discount";
    copyBtn.style.display = "none";
  }
}

// Listen for Shopify variant change event
document.addEventListener("variant:changed", function (event) {
  const newPrice = event.detail.variant.price / 100; // Shopify gives price in paise
  const offerBox = document.querySelector(".offer-box");

  if (!offerBox || isNaN(newPrice)) return;

  offerBox.setAttribute("data-price", newPrice.toFixed(2));
  updateDiscountedPrice(newPrice);
});

// Copy coupon code to clipboard
function copyCoupon() {
  const code = document.getElementById("copy-btn").getAttribute("data-code");
  navigator.clipboard.writeText(code).then(function () {
    const btn = document.getElementById("copy-btn");
    btn.innerText = "Copied!";
    setTimeout(() => {
      btn.innerText = "Copy";
    }, 1500);
  });
}
